import { NgModule } from '@angular/core'
import { PreloadAllModules, RouterModule, Routes } from '@angular/router'
import { NonAuthGuard } from './services/guards/non-auth-guard.service'
import { AuthGuard } from './services/guards/auth-guard.service'

const routes: Routes = [
  { path: '', redirectTo: '/login', pathMatch: 'full' },
  {
    path: 'login',
    loadComponent: () => import('./pages/login/login.page').then((m) => m.LoginPage),
    canActivate: [NonAuthGuard],
  },
  {
    path: 'menu',
    loadChildren: () => import('./pages/menu/menu-routing.module').then((m) => m.MenuPageRoutingModule),
    canActivate: [AuthGuard],
  },
  {
    path: 'superadmin-dashboard',
    loadComponent: () =>
      import('./pages/superadmin/superadmin-dashboard/superadmin-dashboard.page').then(
        (m) => m.SuperadminDashboardPage,
      ),
  },
  // Catch-all for non-existing routes (must be last):
  { path: '**', redirectTo: '/menu/app/tabs/welcome', pathMatch: 'full' },
]

@NgModule({
  imports: [RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules })],
  exports: [RouterModule],
})
export class AppRoutingModule {}
